import Link from "next/link";
import { ChevronRight } from "lucide-react";

interface PublicBreadcrumbItem {
  label: string;
  href?: string;
}

export default function PublicBreadcrumb({
  items,
  className = "",
}: {
  items: PublicBreadcrumbItem[];
  className?: string;
}) {
  if (!items.length) {
    return null;
  }

  return (
    <nav
      aria-label="breadcrumb"
      className={`mb-8 overflow-x-auto whitespace-nowrap scrollbar-hide text-[13px] font-medium text-[#8faecb] ${className}`}
    >
      <div className="flex items-center">
        {items.map((item, index) => (
          <div key={`${item.label}-${index}`} className="flex items-center">
            {index > 0 ? (
              <ChevronRight className="mx-2 h-3 w-3 text-blue-200/40" />
            ) : null}
            {item.href ? (
              <Link href={item.href} className="transition-colors hover:text-white">
                {item.label}
              </Link>
            ) : (
              <span className="rounded bg-white/10 px-2 py-0.5 text-[12px] text-white">
                {item.label}
              </span>
            )}
          </div>
        ))}
      </div>
    </nav>
  );
}
